import React from 'react';
import { IMaskInput } from 'react-imask';
import { INTEGER_MAX, INTEGER_MIN } from '@/constant';

interface DecimalMaskProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  inputRef: (instance: HTMLInputElement | null) => void;
}

const DecimalMask = React.forwardRef<HTMLInputElement, DecimalMaskProps>(
  function DecimalMask(props, ref) {
    const { name, onChange, inputRef, ...other } = props;

    return (
      <IMaskInput
        {...other}
        mask={Number}
        // See IntegerMask: `signed` never reached the mask, `min` is what does.
        min={INTEGER_MIN}
        max={INTEGER_MAX}
        thousandsSeparator=' '
        radix=','
        unmask
        scale={5}
        normalizeZeros={false}
        inputRef={(el) => {
          if (ref) {
            if (typeof ref === 'function') {
              ref(el);
            } else {
              (ref as React.MutableRefObject<HTMLInputElement | null>).current = el;
            }
          }
          inputRef(el);
        }}
        onAccept={(value: string) => {
          onChange({ target: { name, value } });
        }}
        overwrite
      />
    );
  },
);

export default DecimalMask;
